import {
  FulfillmentTypeListResponseType,
  OrderGetResponseType,
  BuyerProductGetResponseType,
  StockListResponseType,
  SupplierGetResponseType,
  SupplierRelationshipGetResponseType,
  SupplierStorefrontV2GetResponseType,
  OpenOrderListResponseType,
} from "@sellar-io/api-v2/types";
import { CalculatedDeliveryOffer } from "@sellar-io/common";
import {
  InfiniteData,
  UseInfiniteQueryResult,
  UseQueryResult,
} from "@tanstack/react-query";
import { createContext } from "react";
import { CheckoutSelectedFulfillmentType } from "../pages";
import { SelectedFulfillmentType } from "../pages/stockList/categoryPage/CategoryPageNavigationBar";

export const StockListContext = createContext<
  | {
      openOrderList: OpenOrderListResponseType;
      supplierQuery: UseQueryResult<SupplierGetResponseType | undefined>;
      productApi: UseQueryResult<BuyerProductGetResponseType | undefined>;
      categoryId?: string;
      supplierIdOrUrlId?: string;
      connection?: Pick<
        SupplierRelationshipGetResponseType,
        "approved" | "fulfillmentType"
      >;
      setEditing: (editing: boolean) => void;
      editing: boolean;
      submittedOrder: OrderGetResponseType | undefined;
      supplierStorefront: SupplierStorefrontV2GetResponseType | undefined;
      setCheckoutSelectedFulfillmentType: (
        fulfillmentType: CheckoutSelectedFulfillmentType,
      ) => void;
      checkoutSelectedFulfillmentType: CheckoutSelectedFulfillmentType;
      basketedProductsQuery:
        | UseInfiniteQueryResult<InfiniteData<StockListResponseType>>
        | undefined;
      calculatedDeliveryOffers: CalculatedDeliveryOffer[];
      setUnAuthorisedUserPostcode: (postcode: string) => void;
      unAuthorisedUserPostcode?: string;
      courierFulfillmentType?: FulfillmentTypeListResponseType[number];
      haulierFulfillmentType?: FulfillmentTypeListResponseType[number];
      setSelectedFulfillmentType: (type: SelectedFulfillmentType) => void;
      selectedFulfillmentType: SelectedFulfillmentType | undefined;
      isStorefrontLoading: boolean;
    }
  | undefined
>(undefined);
